import { timeout } from 'hono/timeout'
import { HTTPException } from 'hono/http-exception'

/**
 * Per-route request timeout middleware.
 * Responds 408 when the handler exceeds `ms` milliseconds.
 */
export function requestTimeout(ms: number) {
  return timeout(
    ms,
    () =>
      new HTTPException(408, {
        res: Response.json(
          { error: { code: 'REQUEST_TIMEOUT', message: `Request timeout after ${ms}ms` } },
          { status: 408 }
        )
      })
  )
}
